import { CSSProperties, FunctionComponent, ReactNode, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

import useIsMounted from '@/hooks/useIsMounted';
import theme from '@/styles/theme';
import { isServer } from '@/types/common';

interface AppContainerProps {
  children: ReactNode;
  isMarginTop?: boolean;
}

const AppContainer: FunctionComponent<AppContainerProps> = ({ children, isMarginTop, ...props }) => {
  const isMounted = useIsMounted();
  const [style, setStyle] = useState<CSSProperties | undefined>();

  useLayoutEffect(() => {
    if (isMounted) {
      const appHeaderHeight = document.getElementById('appHeader')?.clientHeight;
      const footerButtonHeight = document.getElementById('footerButton')?.clientHeight || 0;
      const fixedBottomHeight =
        document.getElementById('FixedBottomSheet')?.clientHeight ||
        document.getElementById('postCommentInput')?.clientHeight ||
        0;
      setStyle({
        paddingTop: appHeaderHeight || 0,
        paddingBottom: footerButtonHeight ? footerButtonHeight + 32 : fixedBottomHeight,
      });
    }
    if (isMarginTop) {
      setStyle({
        ...style,
        marginTop: 8,
      });
    }
  }, [isMounted]);

  return (
    <AppContainerContainer
      {...props}
      style={{
        ...style,
        paddingTop: isServer ? theme.size.appHeader.height : style?.paddingTop,
      }}
    >
      {children}
    </AppContainerContainer>
  );
};

export default AppContainer;

export const AppContainerContainer = styled.main`
  position: relative;
  max-width: ${({ theme }) => theme.size.tablet};
  margin: 0 auto;
`;
